// extracted by mini-css-extract-plugin
module.exports = {"userTokensContainer":"styles_userTokensContainer__3Q-Ij","textContainer":"styles_textContainer__2R4W0","title":"styles_title__1J6zt","subTitle":"styles_subTitle__3y59c"};